import { render, staticRenderFns } from "./SelectProvider.vue?vue&type=template&id=129b2fc2&scoped=true&"
import script from "./SelectProvider.vue?vue&type=script&lang=js&"
export * from "./SelectProvider.vue?vue&type=script&lang=js&"
import style0 from "./SelectProvider.vue?vue&type=style&index=0&id=129b2fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129b2fc2",
  null
  
)

export default component.exports